import * as yup from 'yup';

// Inventory assignment form validation schema
export const inventoryAssignmentValidationSchema = yup.object({
  assigned_to_id: yup
    .number()
    .required('Employee is required')
    .typeError('Employee is required'),
  inventory_item_id: yup
    .number()
    .required('Inventory item is required')
    .typeError('Inventory item is required'),
  quantity: yup
    .number()
    .required('Quantity is required')
    .min(1, 'Quantity must be at least 1')
    .integer('Quantity must be a whole number')
    .typeError('Quantity must be a valid number'),
  assigned_date: yup
    .date()
    .required('Assignment date is required')
    .typeError('Assignment date must be a valid date'),
  remarks: yup
    .string()
    .trim()
    .max(1000, 'Remarks must be less than 1000 characters'),
});